<template>
  <div>
    <div class="columns is-multiline mb-2">
      <div class="column is-6">
        <b-field label="Buscar">
          <b-input
            v-model="searchQuery"
            placeholder="Título, lugar o descripción"
            type="search"
            icon="magnify"
            expanded
            @input="reloadSearch"
            @keydown.native.enter="loadAsyncData"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Estatus">
          <b-select v-model="statusFilter" placeholder="Todos" expanded @input="loadAsyncData">
            <option :value="''">Todos</option>
            <option :value="true">Activo</option>
            <option :value="false">Inactivo</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-3 is-flex is-align-items-flex-end is-justify-content-flex-end">
        <b-button type="is-primary" icon-left="refresh" @click="loadAsyncData">Actualizar</b-button>
      </div>
    </div>

    <b-table
      :data="data"
      :loading="loading"
      :per-page="perPage"
      :total="total"
      backend-pagination
      paginated
      striped
      hoverable
      narrowed
      mobile-cards
      :scrollable="true"
      @page-change="onPageChange"
    >
      <b-table-column field="titulo" label="Reunión" v-slot="props">
        <div class="is-flex is-align-items-center">
          <b-tag :type="props.row.activo ? 'is-success is-light' : 'is-warning is-light'">
            {{ props.row.activo ? 'Activo' : 'Inactivo' }}
          </b-tag>
          <div class="ml-3">
            <p class="has-text-weight-semibold">{{ props.row.titulo }}</p>
            <small class="has-text-grey"> {{ props.row.descripcion || 'Sin descripción' }} </small>
          </div>
        </div>
      </b-table-column>

      <b-table-column field="fecha" label="Fecha" width="150" v-slot="props">
        {{ props.row.fecha || 'Por definir' }}
      </b-table-column>

      <b-table-column field="lugar" label="Lugar" v-slot="props">
        {{ props.row.lugar || 'Por definir' }}
      </b-table-column>

      <b-table-column field="acciones" label="Acciones" width="180" v-slot="props">
        <div class="buttons">
          <b-button
            type="is-primary"
            size="is-small"
            icon-left="eye"
            @click="goToDetail(props.row)"
            title="Ver detalles"
          ></b-button>
          <b-button
            type="is-info"
            size="is-small"
            icon-left="pencil"
            @click="openModal(props.row)"
            title="Editar"
          ></b-button>
          <b-button
            type="is-danger"
            size="is-small"
            icon-left="delete"
            @click="deleteRow(props.row.id)"
            title="Eliminar"
          ></b-button>
        </div>
      </b-table-column>
    </b-table>

    <div class="modal form-modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">{{ formModalData?.id ? 'Editar reunión' : 'Nueva reunión' }}</h2>
          <button @click="closeForm" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Form :key="formKey" :datavalues="formModalData" @close-form="closeForm"></Form>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Swal from 'sweetalert2';
import Form from './form.vue';

export default {
  components: {
    Form,
  },
  data() {
    return {
      formKey: 0,
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
      searchQuery: '',
      statusFilter: '',
      showFormModal: false,
      formModalData: {},
    };
  },
  async mounted() {
    await this.loadAsyncData();
  },
  computed: {
    ...mapState({
      meetings: (state) => state.meetings.list,
      pagination: (state) => state.meetings.pagination,
      reload: (state) => state.meetings.reloadList,
    }),
  },
  watch: {
    async reload(newValue) {
      if (newValue) {
        await this.loadAsyncData();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'meetings/fetchList',
      removeMeeting: 'meetings/removeMeeting',
    }),
    async loadAsyncData() {
      this.loading = true;

      const params = {
        page: this.page,
        size: this.perPage,
        search: this.searchQuery.toLowerCase(),
        status: this.statusFilter,
      };

      await this.fetchList(params);

      this.data = this.meetings;
      this.total = this.pagination.total;

      this.loading = false;
      this.$store.commit('meetings/SET_DATA', { key: 'reloadList', data: false });
    },
    async onPageChange(page) {
      this.page = page;
      await this.loadAsyncData();
    },
    async reloadSearch() {
      if (this.searchQuery.length === 0) {
        await this.loadAsyncData();
      }
    },
    openModal(data) {
      this.formKey++;
      this.showFormModal = true;
      this.formModalData = data;
    },
    closeForm() {
      this.showFormModal = false;
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás recuperar este registro después de eliminarlo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        const response = await this.removeMeeting(id);

        Swal.fire({
          icon: response.status ? 'success' : 'error',
          title: response.message,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        await this.loadAsyncData();
      }
    },
    goToDetail(meeting) {
      this.$router.push({ name: 'meeting-detail', params: { id: meeting.id } });
    },
  },
};
</script>

<style scoped>
.buttons .button + .button {
  margin-left: 6px;
}
</style>
